<template>
  <fragment>
    <template v-for="menu in this.menuData">
      <el-submenu :key="menu.id" :index="menu.id" v-if="menu.children.length > 0">
          <template slot="title">
              <svg-icon :iconName="menu.icon" />
              <span class="menu-title" slot="title">{{ $store.state.locale == 'en' ? (menu.enTitle ? menu.enTitle : menu.title) : menu.title}}</span>
          </template>
          <menu-tree :menuData="menu.children"></menu-tree>
      </el-submenu>
      <router-link :key="menu.id" :to="resolvePath(menu.url)" v-else>
      <el-menu-item :key="menu.id" :index="menu.title" >
          <svg-icon :iconName="menu.icon" />
          <span @click="closeSidebar()" class="menu-title" slot="title">{{ $store.state.locale == 'en' ? (menu.enTitle ? menu.enTitle : menu.title) : menu.title}}</span>
      </el-menu-item>
      </router-link>
    </template>
  </fragment>
</template>
 
<script>
import {viewRuleSetting} from '@/components/common'

export default {
  props: ['menuData'],
  name: 'MenuTree',
  data() {
    return {
      settingData: {
        viewType: '',
        waterId: '',
        immutable: false,
        usageViewTimeUnit: '',
        volumeViewTimeUnit: ''
      },
    }
  },
  created() {

  },
  async mounted() {
    await this.getTimeUnitValue()

    // 不允許自訂範圍
    if (!this.settingData.immutable) {
      const links = document.querySelectorAll('a[href="/viewSetting"]');
      links.forEach(link => {
        link.style.display = 'none';
      });
    }
  },
  methods: {
    resolvePath(url) {
      return this.$router.options.base + url;  // 防止導成相對路徑
    },
    closeSidebar() {
      //呼叫index.vue getWebModeCheckWidth()
      const webModeCheckWidth = this.$parent.$parent.$parent.$parent.$parent.getWebModeCheckWidth();
      if (webModeCheckWidth <= 0) {
        //小網才做點擊menu關sidebar
        this.$parent.$parent.closeMobileSidebar()
      }
    },
    async getTimeUnitValue() {
      this.settingData = await viewRuleSetting()
    }
  }
}
</script>